module.exports = __webpack_public_path__ + "static/img/img6.2af630bb.png";